import { ProductId } from '../product/constants';
import { WLProductT } from '../wl_product/model';

const PRODUCT_DATA = 'PRODUCT_DATA';

export const setProductData = (data: WLProductT) =>
  data
    ? localStorage.setItem(PRODUCT_DATA, JSON.stringify(data))
    : localStorage.removeItem(PRODUCT_DATA);

export const getProductData = (): (WLProductT & { email: string }) | null | undefined => {
  const productData = localStorage.getItem(PRODUCT_DATA);
  return productData && JSON.parse(productData);
};

/** WL product row UUID from cached product details (not the ProductUuid enum). */
export const getCurrentWlProductUuid = (): string | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed?.uuid;
};

export const getCurrentProductTypeId = (): ProductId | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed && productDataParsed.productId;
};

export const getCurrentGroupUuid = (): string | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed?.groupUuid;
};

export const getCurrentLogo = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      fileContent: productDataParsed.logo,
      mimetype: productDataParsed.logoMimetype,
    }
  );
};

export const getCurrentFavicon = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      fileContent: productDataParsed.favicon,
      mimetype: productDataParsed.faviconMimetype,
    }
  );
};

export const getCurrentProductTheme = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      primaryColor: productDataParsed.primaryColor,
      secondaryColor: productDataParsed.secondaryColor,
    }
  );
};

export const getCurrentProductName = (defaultName: string = '') => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.displayName) || defaultName;
};

export const getCurrentProductTerms = () => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.termsUrl) || '';
};

export const getCurrentProductHelpCenterUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.helpCenterUrl;
};

export const getCurrentProductPrivacyUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.privacyUrl;
};

export const getCurrentProductStatusUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.statusUrl;
};

export const getCurrentProductSupportEmail = (defaultName: string = '') => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.email) || defaultName;
};

export const getCurrentProductRewardsEnabled = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.isRewardEnabled;
};

export const getCurrentProductInvitationOnly = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.isInvitationOnly;
};
